/**
 * Minor Electrical Installation Works Certificate (MEIWC) - Default Blank State
 */

const today = new Date().toISOString().split('T')[0];

export default {
  worksDescription: {
    certificateNumber: `MEIWC-${Date.now()}`,
    dateOfWorks: today,
    clientName: '',
    clientAddress: '',
    installationAddress: '',
    descriptionOfWorks: '',
    existingInstallation: ''
  },
  earthingBonding: {
    earthingArrangement: '',
    earthConductor: '',
    mainBonding: '',
    supplementaryBonding: '',
    bondingNotes: ''
  },
  circuitDetails: [
    {
      circuitNumber: '1',
      circuitDescription: '',
      protectiveDevice: '',
      deviceRating: '',
      maxZs: '',
      measuredZs: '',
      rcdType: 'None',
      rcdTripTime1x: '',
      rcdTripTime5x: '',
      insulationResistance: '',
      earthContinuity: '',
      testResult: '',
      notes: ''
    }
  ],
  declaration: {
    engineerName: '',
    engineerCardNumber: '',
    companyName: '',
    schemeName: '',
    schemeReference: '',
    engineerSignature: '',
    customerSignature: ''
  }
};